import Service from "../../Service";
import Axios from "../../Config/API";
import { IEtapaPorGrupo } from "../../../Interfaces/Geral/Etapas/EtapasInterfaces";

export async function InsereEtapaCategoriaAtendimentoTipoCasoGrupoService(
    idTipoCaso: number,
    requestBody: IEtapaPorGrupo
) {
    return Service(
        Axios.post(
            `/home/etapacategoriaatendimentotipocasogrupo/insereetapacategoriaatendimentotipocasogrupo?idTipoCaso=${idTipoCaso}`,
            requestBody,
            { responseType: "json" }
        )
    );
}
export async function DeletaEtapaCategoriaAtendimentoTipoCasoGrupoService(
    idEtapaCategoriaAtendimentoTipoCasoGrupo: number,
    idTipoCaso: number
) {
    return Service(
        Axios.delete(
            `/home/etapacategoriaatendimentotipocasogrupo/deletaetapacategoriaatendimentotipocasogrupo?idEtapaCategoriaAtendimentoTipoCasoGrupo=${idEtapaCategoriaAtendimentoTipoCasoGrupo}&idTipoCaso=${idTipoCaso}`
        )
    );
}
export async function ListarCategoriaAtendimentoTipoCasoService(
    idTipoCaso: number,
    idGrupo: number,
    idCategoriaAtendimento: number
) {
    return Service(
        Axios.get<Array<IEtapaPorGrupo>>(
            `/home/etapacategoriaatendimentotipocasogrupo/listaretapasporgrupo?idGrupo=${idGrupo}&idCategoriaAtendimento=${idCategoriaAtendimento}&idTipoCaso=${idTipoCaso}`
        )
    );
}
export async function ListarEtapasDesvinculadasPorGrupoService(
    idGrupo: number,
    idCategoriaAtendimento: number,
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<IEtapaPorGrupo>>(
            `/home/etapacategoriaatendimentotipocasogrupo/listaretapasdesvinculadasporgrupo?idGrupo=${idGrupo}&idCategoriaAtendimento=${idCategoriaAtendimento}&idTipoCaso=${idTipoCaso}`
        )
    );
}
